export default __webpack_public_path__ + "static/media/zkSync-logo.70961871.svg";